import { toSelectOption } from 'src/util/misc';

export const DEFAULT = 'Use Default';
export const FINISHES = 'Finishes';
export const BLENDING_MODE = 'Blending Mode';
export const PRODUCT_OPTION = 'Product Option';

export const ASSET_ACTIONS = {
    REPLACE: 'REPLACE',
    FILL: 'FILL',
    REMOVE: 'REMOVE',
};
export const ASSET_ACTIONS_OPTIONS = toSelectOption(['REPLACE', 'FILL', 'REMOVE']);

export const DOCUMENT_ACTIONS = {
    BLENDING_MODE: 'blendingMode',
    FINISHES: 'finish',
};

export const PURPOSES_OPTIONS = [
    { label: 'Product Full', value: 'Product:Full' },
    { label: 'Product Closeup', value: 'Product:Closeup' },
    { label: 'Product Alternate', value: 'Product:Alternate' },
    { label: 'Design Overlay', value: 'Design:Overlay' },
    { label: 'Design Underlay', value: 'Design:Underlay' },
];

export const MERCHANDISING = {
    value: 'Merchandising',
    label: 'Merchandising',
};

export const SCENE_VARIABLE_TYPES = {
    'Asset Change': 'Asset Change',
    Cropping: 'Cropping',
};
export const SCENE_VARIABLE_TYPES_OPTIONS = toSelectOption(['Asset Change', 'Cropping']);

export const PRODUCT_VARIABLE_TYPES = {
    product: PRODUCT_OPTION,
    blending: BLENDING_MODE,
    finishes: FINISHES,
};
export const PRODUCT_VARIABLE_TYPES_OPTIONS = toSelectOption([PRODUCT_OPTION, BLENDING_MODE, FINISHES]);

export const BLENDING_MODES = {
    Normal: 'Normal',
    Multiple: 'Multiply',
};
export const BLENDING_MODES_OPTIONS = toSelectOption(['Normal', 'Multiply']);

export const SURFACE_ACTIONS = {
    INCREMENT: 'INCREMENT',
    DECREMENT: 'DECREMENT',
    REPLACE: 'REPLACE',
};
